var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadioSelectedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".Master_Radio"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.625,
    y: 0.625,
    width: 18.75,
    height: 18.75,
    rx: 9.375,
    fill: "var(--fill-0, #046242)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.625,
    y: 0.625,
    width: 18.75,
    height: 18.75,
    rx: 9.375,
    stroke: "var(--stroke-0, #046242)",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 8",
    cx: 10,
    cy: 10,
    r: 3.75,
    fill: "var(--fill-0, #FAFAFA)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioSelectedIcon);
export default __webpack_public_path__ + "static/media/radio-selected-icon.972c3cf19106b88589a4eb4821cc1cfa.svg";
export { ForwardRef as ReactComponent };